"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFastaLines = formatFastaLines;
exports.formatSeqFasta = formatSeqFasta;

/**
 * Returns sequence with new line every 80 characters
 * ref https://stackoverflow.com/a/51506718/2129219
 *
 * @param seqString -  string
 * @returns formated sequence string
 */
function formatFastaLines(seqString) {
  return seqString.replace(/(.{1,80})/g, '$1\n').trimEnd();
}
/**
 * Formats the sequences chunks into Fasta format
 *
 * @param chunks - array of seq chunks of the form `{ header: string, seq: string }`
 * @returns formatted sequence in fasta format
 */


function formatSeqFasta(chunks) {
  return chunks.map(function (chunk) {
    return ">".concat(chunk.header, "\n").concat(formatFastaLines(chunk.seq));
  }).join('\n');
}